import Amap from './src/main';

/* istanbul ignore next */
Amap.install = function(Vue) {
  Vue.component(Amap.name, Amap);
};

export default Amap;
